import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CoreModule } from "@tylertech/core-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { LgdDatePickerModule, LgdSelectModule } from "@tylertech/lgd-reactive-forms";
import { getLoggerFor } from "@tylertech/logging";
import { MetadataModule } from "@tylertech/metadata-module";
import * as components from "./components";
import * as services from "./services";

import "./registerChartjsElements";

const log = getLoggerFor("ChartingModule");

const angularModules = [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule
];

const angularMaterialModules = [
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    MatPaginatorModule,
];

const lgdModules = [
    CoreModule,
    CommonComponentsModule,
    CustomViewModule,
    LgdDatePickerModule,
    LgdSelectModule,
    LgdSelectModule,
    MetadataModule
];

const exportedComponents = [
    components.CommonChartComponent,
    components.CommonChartDateOptionsComponent,
    components.LgdChartComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: [
        ...exportedComponents,
        components.CommonChartInfoCardComponent,
        services.ChartDialogComponent
    ],
    exports: exportedComponents,
    providers: [
        services.ChartService,
        services.ChartDialogService,
        services.ChartManagerService,
        services.OrgChartService,
        services.ChartRegistryService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChartingModule
{ }
